import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Clock, CalendarDays, BarChart3, LogOut, ExternalLink } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const linkBase = "flex items-center gap-3 px-4 py-3 rounded-md font-body text-sm transition-colors";
  const linkClass = ({ isActive }) =>
    `${linkBase} ${isActive ? "bg-white/10 text-white" : "text-white/70 hover:text-white hover:bg-white/5"}`;

  return (
    <div className="min-h-screen flex bg-brand-bg" data-testid="admin-layout">
      <aside className="w-64 bg-brand-primary text-white flex flex-col p-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-9 h-9 rounded-md bg-white/10 flex items-center justify-center">
            <Clock className="w-5 h-5" />
          </div>
          <div>
            <p className="font-heading text-lg font-semibold tracking-tight">Volunteer Clock</p>
            <p className="text-xs text-white/60">Admin console</p>
          </div>
        </div>

        <nav className="space-y-1 flex-1">
          <NavLink to="/admin" end className={linkClass} data-testid="nav-overview">
            <BarChart3 className="w-4 h-4" /> Overview
          </NavLink>
          <NavLink to="/admin/events" className={linkClass} data-testid="nav-events">
            <CalendarDays className="w-4 h-4" /> Events
          </NavLink>
          <NavLink to="/admin/records" className={linkClass} data-testid="nav-records">
            <Clock className="w-4 h-4" /> Records
          </NavLink>
        </nav>

        <div className="pt-6 border-t border-white/10 space-y-3">
          <a
            href="/" target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors"
            data-testid="open-public-link"
          >
            <ExternalLink className="w-4 h-4" /> Public time clock
          </a>
          {user && (
            <div className="text-xs text-white/60">
              <p className="text-white/90 font-medium truncate">{user.name || user.email}</p>
              <p className="truncate">{user.email}</p>
            </div>
          )}
          <button
            onClick={handleLogout} data-testid="logout-button"
            className="w-full flex items-center gap-2 text-sm text-white/80 hover:text-white transition-colors"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 p-8 lg:p-12 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
